import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IExceedMaxPriceBalance } from '../interface/IExceedMaxPriceBalance';

enum ExceedMaxPriceBalanceServiceEnum {
  get = "/",
}

export default class ExceedMaxPriceBalanceService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/exceed-max-price-balance");
  }

  public getById = async (id: number): Promise<IExceedMaxPriceBalance> => await this.GET(ExceedMaxPriceBalanceServiceEnum.get + id);
}
